<template>
  <div class="container">
    <div class="container-side">
      <Sidebar
        :menus="menus"
        :component="component"
        :parent="parent"
        @change="handleChange"
      />
    </div>
    <div class="container-component">
      <component :is="currentComponent" />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/experimentation/sidebar.vue'
import diffuseknowledge from './components/diffuse/knowledge.vue'
import diffusethinking from './components/diffuse/thinking.vue'
import Arrangement from './components/layout/arrangement.vue'
import History from './components/layout/history.vue'
import Location from './components/layout/location.vue'
import Thinking from './components/layout/thinking.vue'
export default {
  name: '',
  components: {
    Sidebar,
    diffuseknowledge,
    diffusethinking,
    Arrangement,
    History,
    Location,
    Thinking
  },
  props: [],
  data() {
    return {
      menus: [
        {
          label: 'lang.title.妈祖信仰海外传播',
          value: 1,
          parent: 0,
          children: [
            {
              label: 'lang.mz.one.zs',
              value: 2,
              parent: 1,
              component: diffuseknowledge,
            },
            {
              label: 'lang.mz.one.wt',
              value: 3,
              parent: 1,
              component: diffusethinking,
            },
          ],
        },
        {
          label: 'lang.title.天后宫空间布局',
          value: 4,
          parent: 0,
          children: [
            {
              label: 'lang.mz.two.dl',
              value: 5,
              parent: 4,
              component: Location,
            },
            {
              label: 'lang.mz.two.cj',
              value: 6,
              parent: 4,
              component: History,
            },
            {
              label: 'lang.mz.two.kj',
              value: 7,
              component: Arrangement,
              parent: 4,
            },
            {
              label: 'lang.mz.two.ll',
              value: 8,
              parent: 4,
              component: Thinking,
            },
          ],
        },
      ],
      component: 2,
      currentComponent: diffuseknowledge,
      parent: null,
    }
  },
  methods: {
    handleChange(val) {
      if (val.children) {
        this.parent = val.value
      } else {
        this.parent = val.parent
        this.component = val.value
        if (val.component) {
          this.currentComponent = val.component
        } else {
          this.$router.push(val.path)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: calc(90vh - 100px);
  display: flex;
  &-side {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 24px;
    padding-left: 3vw;
  }
  &-component {
    height: 100%;
    flex: 1;
    padding-right: 3vw;
    padding-bottom: 5vh;
    ::v-deep {
      .main {
        width: 100%;
        height: 100%;
        padding: 3px;
      }
    }
  }
}
</style>